import SceneController from 'controllers/sceneController';
import ReactWrapper from "views/marionetteReactWrapper";
import { GeneralSettingsPlaceholder } from "./GeneralSettingsPlaceholder";
import React from "react";
import axios from "axios";
import { GeneralSettingsView } from "./GeneralSettingsView";

export default class GeneralSceneController extends SceneController {
  show() {
    this.fetchPdfSettings();
    this.showPlaceholder();
  }

  showPlaceholder() {
    this.showInRightColumn(
      new ReactWrapper({
        getComponent: () => {
          return <GeneralSettingsPlaceholder />;
        },
      })
    );
  }

  async fetchPdfSettings() {
    const url = "/api/v3/pdf_settings";
    try {
      const resp = await axios.get(url);
      const isPdfWithoutBranding = !!(
        resp && resp.data && resp.data.pdf_without_branding
      );

      this.showInLeftColumn(
        new ReactWrapper({
          getComponent: () => {
            return <GeneralSettingsView isPdfWithoutBranding={isPdfWithoutBranding} />;
          },
        })
      );
    } catch (err) {
      console.error("Failed to load PDF settings", err);
    }
  }
}
